import logo from "assets/images/dentsu-logo.png";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-links">
          <a
            href="https://www.dentsu.com/uk/en/policies/responsible-disclosure-policy"
            target="_blank"
          >
            Responsible Disclosure Policy
          </a>
          <a
            href="https://forms.monday.com/forms/e497e63ae879c33a0bfe722d9f323b72?r=use1"
            target="_blank"
          >
            Give feedback
          </a>
        </div>
        <a href="https://www.dentsu.com" target="_blank">
          <img className="logo" src={logo} alt="dentsu" />
        </a>
      </div>
    </footer>
  );
}
